import { createNotification, type GlobalConfig } from '@repo/go-ui';
import type { i18n } from 'i18next';

import type { GoStorageObject } from '../../../shared/api/IDashboardService';
import { CreateTemplateForm } from '../../../shared/components/CreateTemplateForm/CreateTemplateForm';
import modalBox from '../../../shared/components/ModalBox/modalBox';
import styles from '../AlertRulesTable.module.css';
import type { TAlertRulesTemplateData } from '../services/AlertRulesTemplatesManager';
import { AlertRulesTemplatesManager } from '../services/AlertRulesTemplatesManager';

export function openEditTemplateModal(
  template: GoStorageObject<TAlertRulesTemplateData>,
  templateManager: AlertRulesTemplatesManager,
  configProvider: GlobalConfig,
  i18n: i18n,
) {
  modalBox({
    configProvider,
    modalBody: (close) => (
      <div style={{ width: 440 }}>
        <div className={styles.modalTitle}>{i18n.t('alertsManagerWidget:alertRules.templatesDrawer.editTemplate')}</div>
        <CreateTemplateForm
          onSubmit={(values) => {
            templateManager
              .updateTemplateName(template.id, values.name, values.description)
              .then(() => {
                close('ok');
              })
              .catch((e: Error) => {
                createNotification({
                  title: 'Error',
                  text: e.name,
                  type: 'error',
                });
              });
          }}
          defaultValues={template.data}
          maxNameLength={AlertRulesTemplatesManager.MAX_TEMPLATE_NAME_LENGTH}
          maxDescriptionLength={AlertRulesTemplatesManager.MAX_TEMPLATE_DESCRIPTION_LENGTH}
          onCancel={() => close('cancel')}
          labels={{
            name: 'alertsManagerWidget:alertRules.templatesDrawer.name',
            description: 'alertsManagerWidget:alertRules.templatesDrawer.description',
            errorTextMaxLength: 'alertsManagerWidget:alertRules.templatesDrawer.errorTextMaxLength',
            submitButtonMessage: 'alertsManagerWidget:alertRules.templatesDrawer.submitButtonMessage',
            cancelButtonMessage: 'alertsManagerWidget:alertRules.templatesDrawer.cancelButtonMessage',
          }}
          i18n={i18n}
        />
      </div>
    ),
  });
}
